import type { Locale } from '@skytech/types'
export type SortingMode = 'off' | 'asc' | 'desc'

export const sortListBy = <T extends {}>({
  list,
  sortBy,
  sortingMode,
  locale,
}: {
  list: T[]
  sortBy: keyof T
  sortingMode: SortingMode
  locale?: Locale
}) =>
  list.sort((a, b) => {
    const firstElement = String(a[sortBy] || '')
    const secondElement = String(b[sortBy] || '')

    return sortingMode === 'asc'
      ? firstElement.localeCompare(secondElement, locale, { sensitivity: 'base', numeric: true })
      : secondElement.localeCompare(firstElement, locale, { sensitivity: 'base', numeric: true })
  })

export const getSortedList = <T extends {}>({
  list,
  querySort,
  querySortBy,
  locale,
}: {
  list: T[]
  querySort: string | null
  querySortBy: string | null
  locale?: Locale
}) => {
  if (list.length === 0) return list
  if (!querySortBy || !querySort || querySort === 'off' || !['asc', 'desc'].includes(querySort))
    return list

  // If user attempts to sort by an inexistent column, return the original record list
  if (!Object.keys(list?.[0]).includes(querySortBy)) return list
  const sortBy = querySortBy as keyof T
  const sort = querySort as SortingMode

  return sortListBy({
    list,
    locale,
    sortBy,
    sortingMode: sort,
  })
}
